<template>
  <div>
    <b-modal ref="my-modal" centered hide-footer title="Edit Leave Type">
      <form v-on:submit.prevent="doSubmit">
        <label for="" class="mt-2 labels">Name *</label>
        <b-form-input type="text" class="mb-3" placeholder="Enter Name" v-model="model.name" name="name" v-bind:class="errors.has('name') ? 'is-invalid':''" v-validate="'required'"></b-form-input>
        <label for="" class="mt-2 labels">Quota *</label>
        <input type="number" pattern="[0-9]+([\.,][0-9]+)?" step="0.01" class="mb-3 form-control" placeholder="Enter Quota" v-model="model.quota" name="quota" v-bind:class="errors.has('quota') ? 'is-invalid':''" v-validate="'required'" />
         <b-form-checkbox
            id="checkbox-1"
            v-model="model.isLeavePhoto"
            name="checkbox-1"
            value="true"
            unchecked-value="false"
            class="mt-2"
          >
            Leave Photo ?
          </b-form-checkbox>
        <b-button class="mt-3" variant="secondary" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
        <b-button class="mt-3 float-right" variant="warning" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> Update</b-button>
      </form>
    </b-modal>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        apiUrl: {
          leaveType: window.AppConfig.apiUrl + 'leave-type',
        },
        model: {
          uuid: null,
          name: null,
          quota: null,
          isLeavePhoto: null
        }
      }
    },
    methods: {
      doSubmit () {
        this.$validator.validateAll().then(res => {
          if (res) {
            if (this.model.uuid !== null) {
              this.$http.patch(this.apiUrl.leaveType + '/' + this.model.uuid, {
                name: this.model.name,
                quota: this.model.quota,
                isLeavePhoto: this.model.isLeavePhoto
              }).then(response => {
                this.$store.dispatch('notification/success', 'Leave type has been updated.')
                this.hideModal()
                this.resetData()
                this.$emit('getLeaveType')
              }).catch(error => {
                this.$store.dispatch('notification/error', error)
              })
            }
          }
        })
      },
      resetData () {
        this.model.uuid = null
        this.model.name = null
        this.model.quota = null
        this.model.isLeavePhoto = null
        this.$validator.reset()
      },
      showModal(row) {
        this.model.uuid = row.uuid
        this.model.name = row.name
        this.model.quota = row.quota
        this.model.isLeavePhoto = row.isLeavePhoto
        this.$validator.reset();
        this.$refs['my-modal'].show()
      },
      hideModal () {
        this.resetData()
        this.$refs['my-modal'].hide()
      }
    }
  }
</script>